import * as React from 'react';

import { Table} from '@deere/ux.uxframe-react'
import { Checkbox } from '@mui/material';
import { useTranslation } from "react-i18next";
import { getRequestStatusWhenCampaignClosed } from '../../utils/utils';

export const SupplierGroup = ({ list, onCheck, onCheckAll, selectedSuppliers, campaign, sx }) => {
    const { t } = useTranslation();

    const isSelected = (currSupplier) => {
        return (selectedSuppliers.includes(currSupplier.supplierNumber) || currSupplier.groupNumber?true:false);
    }

    let tableRowStyle;
    if(sx){
        tableRowStyle = sx.tableRowStyle;
    }

    return (
        <div>
            <Table  responsive size="sm">
                <thead>
                    <tr>
                        <th scope="col" className="text-left" style={tableRowStyle}><Checkbox onChange={onCheckAll}/>{t('cm_lbl_supplier')}</th>
                        <th scope="col" className="text-left"></th>
                    </tr>
                </thead>
                <tbody>
                    {
                         list.map((supp, index) =>
                         <tr id={index} key={index}>
                            <td className="text-left" style={tableRowStyle}><Checkbox onChange={onCheck} checked={isSelected(supp)} value={supp.supplierNumber} disabled={supp.groupNumber?true:false}/>
                                {supp.supplierName} (Request {supp.id} Status: {supp && campaign ? getRequestStatusWhenCampaignClosed(supp.status, campaign.status) : ""})
                            </td>
                            <td className="text-left"></td>
                        </tr>
                     )
                    }
                </tbody>
            
            </Table>
        </div>
      );
}